import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import Header from '../components/Header';

const ContactCompleted = () => {
    const location = useLocation();
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const { opportunityId } = location.state || {};
    return (
        <div>

            {/* メインコンテンツ */}
            <section className="section-login main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-8 col-sm-10 mx-auto">
                            <div className="login-wrapper bg-white rounded-50 theme-box-shadow-2 p-lg-5 p-4 text-center">
                                <div className="p-lg-4">
                                    <img
                                        className="img img-fluid img-success mb-3"
                                        src="assets/images/registration/success-icon.svg"
                                        alt="Success"
                                    />
                                    <div className="text-red-03 text-custom-xl-1 fw-400 mb-lg-5 mb-4">SUCCESS</div>
                                    <div className="text-sm mb-lg-5 mb-4 fw-400">問い合わせを送信しました。<br />
                                        企業から返信があった場合は通知されます。</div>
                                    {/* リンクボタン */}
                                    {/* <Link to="/bidding"> */}
                                    <Link to={`/project_detail?${opportunityId}`} >

                                        <button type="button" className="btn btn-theme btn-danger rounded-pill px-lg-5 mb-5">
                                            <span className="px-lg-5 px-4">応札中一覧へ</span>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </section >

            {/* フッター部分 */}
            <Footer />
        </div >
    );
};

export default ContactCompleted;
